import React, {useEffect, useState} from 'react'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Grid from '@material-ui/core/Grid'
import WidgetBar from 'Components/WidgetBar'
import DatePicker from 'Components/DatePicker'
import moment from 'moment'
import Select from 'Components/Select'
import User from 'EurestoClass/User'

moment.locale('fr')

export default props => {

  const [date, setDate] = useState([moment().subtract(7, 'days').startOf('week').format('YYYY-MM-DD'), moment().subtract(7, 'days').endOf('week').format('YYYY-MM-DD')])
  const [view, setView] = useState(1)

  useEffect(() => {
    setDate(
      view === 1 && [moment().subtract(7, 'days').startOf('week').format('YYYY-MM-DD'), moment().subtract(7, 'days').endOf('week').format('YYYY-MM-DD')]
      || view === 2 && [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
      || view === 3 && [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')]
    )
  }, [view])

  return <Grid item style={{ margin: 0, padding: 10 }} xs={12}>
    <EurestoDiv titleStyle={{ padding: 0 }} title={
      <Grid wrap={'nowrap'} spacing={0} style={{ margin: 0, padding: 0, fontWeight: 'normal' }} container
            justify={'center'}
            alignContent={'center'} alignItems={'center'}>
        <Grid item xs>
          <span style={{ textAlign: 'center', width: 1000, padding: '0px 10px', fontWeight: 'bold' }}>Historique de vos tickets</span>
        </Grid>
        <Grid item>
          <Select key={view} InputProps={{ style: { marginBottom: 0 } }} onChange={data => data && setView(data)} value={view} options={[{
            label: 'Semaine',
            value: 1
          }, {
            label: 'Mois',
            value: 2
          }, {
            label: 'Année',
            value: 3
          }]}/>
        </Grid>
        <Grid item>
          <DatePicker value={date}
                      clearDate={false}
                      month={view === 2}
                      year={view === 3}
                      week={view === 1}
                      style={{ marginBottom: 0 }}
                      onChange={data => {
                        setDate(data)
                      }}/>
        </Grid>
      </Grid>} style={{ padding: 0, margin: 0 }}>
      <WidgetBar
        year={view === 3}
        module={'sdd'}
        requete={'action'}
        champ_recherche={'date_creation'}
        date_debut={date && date[0]}
        date_fin={date && date[1]}
        barData={[
          {
            title: 'Courbe tickets non traités',
            color: EurestoColor('EurestoError'),
            recherche: [{ champ: 'user_assign_id', operation: 'egal', 'valeur': User.User.get().id }],
            accumulation: true,
            filter: (o, date) =>
              ((o.etat === 0) && moment(o.date_creation).isSameOrBefore(date, view === 3 && 'month' || 'day')) ||
              ((o.etat === 1) && moment(o.date_creation).isSameOrBefore(date, view === 3 && 'month' || 'day')
                && moment(o.date_modification).isAfter(date, view === 3 && 'month' || 'day'))
          },
          {
            title: 'Tickets traités',
            champ_recherche: 'date_modification',
            color: EurestoColor('EurestoPrimary'),
            recherche: [{ champ: 'etat', operation: 'egal', 'valeur': 1 }, {
              champ: 'user_assign_id',
              operation: 'egal',
              'valeur': User.User.get().id
            }]
          },
          {
            title: 'Tickets créés',
            color: EurestoColor('EurestoSecondary'),
            recherche: [{
              champ: 'user_id',
              operation: 'egal',
              'valeur': User.User.get().id
            }, { champ: 'user_assign_id', operation: 'egal', 'valeur': null, non: true }]
          }]}/>
    </EurestoDiv>
  </Grid>
}


// WEBPACK FOOTER //
// ./app/App/Module/Home/Component/Widgets/Dossier/index.js